module.exports = __webpack_public_path__ + "img/aeroland-software-image-05.a7c4e815.png";